import { constantTree } from "../../../core/events/ConstantTree";

export const multiBookTree = constantTree({
    PlanMultiBook: {
        Back: {
            Click: ""
        },
        Continue: {
            Click: ""
        }
    },
    ticketOptions: {
        get: ""
    },
    seatingPreferences: {
        get: ""
    },
    MultiBook: {
        Back: {
            Click: ""
        },
        ModifyDate: "",
        Continue: {
            Click: ""
        },
        ChangeTrain: {
            GetOffers: "",
            SelectOffer: "",
        },
        Booking: {
            Checkbox: {
                Click: ""
            }
        }
    }
})